import { Component, forwardRef } from '@angular/core';
import { CommonExplainModule } from '../../common-explain/common-explain.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-feature-explanation-modal-smart-search',
  standalone: true,
  imports: [forwardRef(() => CommonExplainModule), TranslateModule],
  templateUrl: './feature-explanation-modal-smart-search.component.html',
  styleUrl: './feature-explanation-modal-smart-search.component.scss',
})
export class FeatureExplanationModalSmartSearchComponent {
  constructor(protected modal: NgbActiveModal) {}
}
